module.exports = __webpack_public_path__ + "img/earn_feed_super_discount@3x.fc414b1b.png";